import { App as AntdApp } from 'antd';
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const MESSAGE_KEY = 'editor-load';

// Loads the stored record an editor opens on. One load at a time, so a double click cannot open it twice.
export function useEditorLoad() {
  const { message } = AntdApp.useApp();
  const { t } = useTranslation();
  const inFlight = useRef(false);

  return useCallback(
    <T>(load: () => Promise<T>, open: (record: T) => void) => {
      if (inFlight.current) return;
      inFlight.current = true;
      message.open({ key: MESSAGE_KEY, type: 'loading', content: t('common-loading'), duration: 0 });
      load()
        .then(open)
        // The API interceptor already reports a failed request.
        .catch(() => undefined)
        .finally(() => {
          inFlight.current = false;
          message.destroy(MESSAGE_KEY);
        });
    },
    [message, t]
  );
}
